import { PathCommand, ShapeConstants } from '../constant';

import type { PathContent, PathCommandVal } from '../types/shape';
import type { D } from '../types/css';

function f(value: number, digits: number = 3): string {
  return value.toFixed(digits);
}

/**
 * 转换pathContent数组为路径属性d.
 *
 * @remarks
 * 目前UI设计器对路径的描述只用到3种命令，分别是:
 * 1、(Move to): 移动画笔;
 * 2、(Line to): 画直线;
 * 3、(Curve to): 画三次贝塞尔曲线;
 *
 * @param content - pathContent数组.
 * @returns 路径属性d.
 */
export function transPathContentToD(content: PathContent): D {
  const hasPathContent: boolean = Array.isArray(content) && content.length && !!content[0][ShapeConstants.command];

  if (!hasPathContent) {
    return null;
  }

  let d = '';

  for (const path of content) {
    const params = path[ShapeConstants.params];
    const x1 = params[ShapeConstants.c1x];
    const y1 = params[ShapeConstants.c1y];
    const x2 = params[ShapeConstants.c2x];
    const y2 = params[ShapeConstants.c2y];
    const x  = params[ShapeConstants.x];
    const y  = params[ShapeConstants.y];

    const command: PathCommandVal = path[ShapeConstants.command];

    switch (command) {
      case PathCommand.MoveTo:
        d += `M ${f(x)} ${f(y)}`;
        break;
      case PathCommand.LineTo:
        d += ` L ${f(x)} ${f(y)}`;
        break;
      case PathCommand.CurveTo:
        d += ` C ${f(x1)} ${f(y1)} ${f(x2)} ${f(y2)} ${f(x)} ${f(y)}`;
        break;
      case PathCommand.ClosePath:
        d += ` Z`;
        break;
    }
  }

  return {
    d,
  };
}
